import { jsLazyLoad } from '../../utils/webComponent';
import { scrollToTop } from '../ui/helpers';

export function reduceAction(state, name, value) {
    return state[name] === value ? state : { ...state, [name]: value };
}

export function loadLibrary(settings) {
    const { libraryUrl } = settings;
    jsLazyLoad(libraryUrl, {}, '').catch(e => window.console.error(e));
}

export function addReviewList(settings, windowSize) {
    const {
        apiKey,
        locale,
        merchantGroupId,
        merchantId,
        pageId,
        reviewWrapperUrl,
        styleSheetUrl,
    } = settings;
    window.pwr =
        window.pwr ||
        function() {
            (pwr.q = pwr.q || []).push(arguments);
        };
    pwr('render', {
        api_key: apiKey,
        locale,
        merchant_group_id: merchantGroupId,
        merchant_id: merchantId,
        page_id: pageId,
        review_wrapper_url: reviewWrapperUrl,
        style_sheet: styleSheetUrl,
        enable_content_collection_modal: false,
        on_back_to_top_click() {
            scrollToReviews(windowSize);
        },
        components: {
            ReviewDisplay: 'pr-reviewdisplay',
        },
    });
}

export function addForm(settings) {
    const { apiKey, locale, merchantGroupId, merchantId, styleSheetUrl } = settings;
    /* global pwr */
    window.pwr =
        window.pwr ||
        function() {
            (pwr.q = pwr.q || []).push(arguments);
        };
    pwr('render', {
        api_key: apiKey,
        locale,
        merchant_group_id: merchantGroupId,
        merchant_id: merchantId,
        style_sheet: styleSheetUrl,
        on_submit() {
            window.scrollTo(0, 0);
        },
        components: {
            Write: 'pr-write',
        },
    });
}

export function scrollToReviews(windowSize) {
    scrollToTop({
        targetElement: document.querySelector('#product-reviews'),
        baseElement: window,
        shift: 0,
        windowSize,
    });
}
